export const cameraPermissionGranted = () => {
  localStorage.setItem('CAM_PERMISSION', 'true');
};

export const isCameraPermissionGranted = () => {
  return localStorage.getItem('CAM_PERMISSION') !== null;
};
